import React, { FC } from 'react';
import ApiLocalizedTextField from '~/components/ApiLocalizedTextField';
import { useGetServiceQuery } from '~/hooks/paymentServices';

interface Props {
  keyPrefix: string;
  label: string;
  operationSubtype?: string;
  serviceId?: string;
  keepStale?: boolean;
}

const OperationSubtypeField: FC<Props> = ({
  keyPrefix,
  operationSubtype,
  serviceId,
  label,
  keepStale,
}) => {
  const { data: service, isLoading } = useGetServiceQuery(serviceId!, false, {
    enabled: !operationSubtype && !!serviceId,
    staleTime: keepStale ? Infinity : undefined,
  });
  return (
    <ApiLocalizedTextField
      keyPrefix={keyPrefix}
      secondKey={operationSubtype}
      fallbackValue={service?.name || service?.id || serviceId}
      label={label}
      isLoading={isLoading}
    />
  );
};

export default OperationSubtypeField;
